module.exports = __webpack_public_path__ + "img/Escuela_primaria_inferior.72e4c391.svg";